import { CountBadge } from 'palette/Filters';
import { ListItem, ListItemLabel } from 'palette/List';
import { Toggle } from 'palette/Toggle';
import { ColorFilterLabel } from '@common/Filters/components/ColorFilterLabel';
import '../styles/FilterItem.scss';

function FilterItem(props) {
    const {
        isTranslate = true,
        value,
        name,
        count,
        filterType,
        activeFilters,
        filterClick
    } = props;

    const isActive = element => (filterType === element.filterType && value === element.value);
    const isSelected = activeFilters.some(isActive);
    const isEmpty = count <= 0;
    const disabledSelected = isSelected && isEmpty;

    const label = isTranslate ? App.Translations.get(name) : name;

    const listItemClickHandler = (event) => {
        event.preventDefault();

        if (!isEmpty || disabledSelected) {
            filterClick(event);
        }
    };

    return (
        <ListItem
            isActive={isSelected}
            isDisabled={isEmpty}
            {...!isEmpty && {
                onClick: listItemClickHandler
            }}
            rightContent={(
                <CountBadge
                    count={count}
                    isDisabled={isEmpty}
                />
            )}
        >
            <ListItemLabel>
                {
                    filterType === 'color' ? (
                        <ColorFilterLabel
                            isChecked={isSelected}
                            isDisabled={isEmpty}
                            label={label}
                            value={value}
                        />
                    ) : (
                        <Toggle
                            id={label}
                            isChecked={isSelected}
                            isDisabled={isEmpty}
                            label={label}
                            variant="checkbox"
                        />
                    )
                }
            </ListItemLabel>
        </ListItem>
    );
}

export default FilterItem;
